import React, { useState, useRef, useEffect } from 'react';
import { flushSync } from 'react-dom';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  Row, Col, Button, Input, Form, notification,
} from 'antd';
import MaskedInput from 'react-text-mask';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import moment from 'moment/moment';
import { getUserMail, getUserType } from '../../../../utils/users';
import UploadFiles from '../uploadFiles/UploadFiles';
import './Summary.scss';
import {
  get, post, isSuperAgentError,
  RequestWrapper, ResponseWrapper,
} from '../../../../dataSource/requests';
import SelectedLands from '../selectedLands/SelectedLands';
import GeoMapSummary from '../geoMapSummary/GeoMapSummary';
import AreaTalhao from '../../../sharedComponents/talhao/AreaTalhao';
import { isItEstimateOrService } from '../../../../utils/service';
import { backendResponseCodes } from '../../../../utils/responseMessages';

const dateFormat = 'DD/MM/YYYY';

const Summary = (props): JSX.Element => {
  const {
    params, previousPage, removeSelectedField, isCurrentPage,
    nextPage,
  } = props;

  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [formInstance] = Form.useForm();

  const uploadFilesReference = useRef(null);
  const [requestId, setRequestId] = useState<number | null>(null);
  const valueAttachmentSizeCooperated = useRef(null);
  const valueAttachmentSizeCoopercitrus = useRef(null);
  const [maxSizeCooperated, setMaxSizeCooperated] = useState<number>(0);

  const arrIdsCodeEstimateFloat = [
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-VALOR_UNITARIO',
    'SATELITE-TAXA_VARIAVEL_N-VALOR_UNITARIO',
    'SATELITE-MAPA_TCH-VALOR_UNITARIO',
    'SATELITE-LEVANTAMENTO_PRAGAS-VALOR_UNITARIO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-VALOR_TOTAL',
    'SATELITE-TAXA_VARIAVEL_N-VALOR_TOTAL',
    'SATELITE-MAPA_TCH-VALOR_TOTAL',
    'SATELITE-LEVANTAMENTO_PRAGAS-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-PASTAGEM-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-LINHA-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-CARRETA-VALOR_UNITARIO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-PASTAGEM-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-LINHA-VALOR_TOTAL',
    'APLICACAO_CORRETIVOS-CARRETA-VALOR_TOTAL',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-VALOR_UNITARIO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-VALOR_TOTAL',
    'VANT-ORTOMOSAICO-VALOR_UNITARIO',
    'VANT-PROJETO_PLANTIO-VALOR_UNITARIO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-VALOR_UNITARIO',
    'VANT-MAPEAMENTO_LINHAS-VALOR_UNITARIO',
    'VANT-LEVANTAMENTO_FALHAS-VALOR_UNITARIO',
    'VANT-ZONA_MANEJO-VALOR_UNITARIO',
    'VANT-ORTOMOSAICO-VALOR_TOTAL',
    'VANT-PROJETO_PLANTIO-VALOR_TOTAL',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-VALOR_TOTAL',
    'VANT-MAPEAMENTO_LINHAS-VALOR_TOTAL',
    'VANT-LEVANTAMENTO_FALHAS-VALOR_TOTAL',
    'VANT-SISTEMATIZACAO-VALOR_UNITARIO',
    'VANT-SISTEMATIZACAO-VALOR_TOTAL',
    'VANT-ZONA_MANEJO-VALOR_TOTAL',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-VALOR_UNITARIO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-VALOR_TOTAL',
  ];

  const arrIdsCodeEstimateString = [
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-CONDICAO_PAGAMENTO',
    'SATELITE-TAXA_VARIAVEL_N-CONDICAO_PAGAMENTO',
    'SATELITE-MAPA_TCH-CONDICAO_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PRAGAS-CONDICAO_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-FORMA_PAGAMENTO',
    'SATELITE-TAXA_VARIAVEL_N-FORMA_PAGAMENTO',
    'SATELITE-MAPA_TCH-FORMA_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PRAGAS-FORMA_PAGAMENTO',
    'SATELITE-LEVANTAMENTO_PLANTAS_DANINHAS-OBSERVACOES',
    'SATELITE-TAXA_VARIAVEL_N-OBSERVACOES',
    'SATELITE-MAPA_TCH-OBSERVACOES',
    'SATELITE-LEVANTAMENTO_PRAGAS-OBSERVACOES',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-PASTAGEM-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-LINHA-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-CARRETA-CONDICAO_PAGAMENTO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-PASTAGEM-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-LINHA-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-CARRETA-FORMA_PAGAMENTO',
    'APLICACAO_CORRETIVOS-AREA_TOTAL-OBSERVACOES',
    'APLICACAO_CORRETIVOS-PASTAGEM-OBSERVACOES',
    'APLICACAO_CORRETIVOS-LINHA-OBSERVACOES',
    'APLICACAO_CORRETIVOS-CARRETA-OBSERVACOES',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-CONDICAO_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-FORMA_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_TOTAL-OBSERVACAO',
    'VANT-ORTOMOSAICO-CONDICAO_PAGAMENTO',
    'VANT-PROJETO_PLANTIO-CONDICAO_PAGAMENTO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-CONDICAO_PAGAMENTO',
    'VANT-MAPEAMENTO_LINHAS-CONDICAO_PAGAMENTO',
    'VANT-LEVANTAMENTO_FALHAS-CONDICAO_PAGAMENTO',
    'VANT-SISTEMATIZACAO-CONDICAO_PAGAMENTO',
    'VANT-ZONA_MANEJO-CONDICAO_PAGAMENTO',
    'VANT-ORTOMOSAICO-FORMA_PAGAMENTO',
    'VANT-PROJETO_PLANTIO-FORMA_PAGAMENTO',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-FORMA_PAGAMENTO',
    'VANT-MAPEAMENTO_LINHAS-FORMA_PAGAMENTO',
    'VANT-LEVANTAMENTO_FALHAS-FORMA_PAGAMENTO',
    'VANT-SISTEMATIZACAO-FORMA_PAGAMENTO',
    'VANT-ZONA_MANEJO-FORMA_PAGAMENTO',
    'VANT-ORTOMOSAICO-OBSERVACOES',
    'VANT-PROJETO_PLANTIO-OBSERVACOES',
    'VANT-MAPEAMENTO_ERVAS_INVASORAS-OBSERVACOES',
    'VANT-MAPEAMENTO_LINHAS-OBSERVACOES',
    'VANT-LEVANTAMENTO_FALHAS-OBSERVACOES',
    'VANT-SISTEMATIZACAO-OBSERVACOES',
    'VANT-ZONA_MANEJO-OBSERVACOES',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-CONDICAO_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-FORMA_PAGAMENTO',
    'SPRAY_DRONE-APLICACAO_AREA_CATACAO-COM_MAPA_ERVA_DANINHA-OBSERVACOES',
  ];

  const titleOrcamento = useRef(false);

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const mask = (rawValue: string): (string | RegExp)[] => {
    if (rawValue.length > 14) {
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ];
    }
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  };

  const getAttachmentParamenters = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = get({
        url: '/system/getAttachmentParamenters',

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 8005):
        // "Attachment Paramenters Got Successfully", 8005
        valueAttachmentSizeCooperated.current = response
          ?.body
          .getAttachmentParamentersOutput
          .attachmentSizeCooperated;

        setMaxSizeCooperated(response?.body.getAttachmentParamentersOutput.attachmentSizeCooperated);

        valueAttachmentSizeCoopercitrus.current = response
          ?.body
          .getAttachmentParamentersOutput
          .attachmentSizeCoopercitrus;
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      default:
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao buscar as informações, por favor '
            + 'tente novamente mais tarde',
        });
        break;
    }
  };

  useEffect(() => {
    getAttachmentParamenters();
    return () => {
      setLoading(false);
    };
  }, []);

  const userMailCooperative = (): JSX.Element => {
    const targetMail = getUserMail() ? getUserMail()?.replaceAll('"', '') : '-';

    return (
      <div>
        <div>
          <span>{`Email: ${getUserType() === 'COOPERATIVE' ? targetMail : '-'}`}</span>
        </div>
        <div>
          <span style={{ fontSize: '.7rem' }}>(caso esteja incorreto, informar e-mail válido no campo observação)</span>
        </div>
      </div>
    );
  };

  const { TextArea } = Input;

  const getGeofertGridSummary = (parameters): JSX.Element => (
    <Row gutter={24}>
      <Col span={24}>
        {
          params.selectedSubType !== undefined
          && (
            <Row className="param-row" justify="space-between">
              <Col>
                {`Tipo de ${params.selectedType.name}`}
              </Col>
              <Col><b>{params.selectedSubType.name}</b></Col>
            </Row>
          )
        }

        {
          parameters.selectedType.id === 2
          && parameters.gridType
          && parameters.gridType.val === 3
          && parameters.gridSize !== undefined
          && (
            <Row className="param-row">
              <Col span={24}>
                <Row justify="space-between">
                  <Col>Tamanho do grid:</Col>
                  <Col><b>{`${parameters.gridSize} hectares`}</b></Col>
                </Row>
              </Col>
            </Row>
          )
        }

        {
          parameters.selectedType.id === 2
          && parameters.gridType
          && parameters.gridType.val === 3
          && (
            <div>
              <Row className="param-row">
                Amostragem da camada 0-20cm:
              </Row>
              {
                parameters.layer020Rotina
                  ? (
                    <div>
                      <Row className="section-row">
                        <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Rotina, Alumínio e Enxofre:</Col>
                            <Col><b>{`Proporção ${parameters.proportionRotina020}`}</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
                  : (
                    <div>
                      <Row className="section-row">
                        <Col className="title" xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Rotina, Alumínio e Enxofre:</Col>
                            <Col><b>Não Solicitada</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
              }

              {
                parameters.layer020Micro
                  ? (
                    <div>
                      <Row className="section-row">
                        <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Micro:</Col>
                            <Col><b>{`Proporção ${parameters.proportionMicro020}`}</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
                  : (
                    <div>
                      <Row className="section-row">
                        <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Micro:</Col>
                            <Col><b>Não solicitada</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
              }

              {
                parameters.layer020Fisica
                  ? (
                    <div>
                      <Row className="section-row">
                        <Col className="title" xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Física:</Col>
                            <Col><b>{`Proporção ${parameters.proportionFisica020}`}</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
                  : (
                    <div>
                      <Row className="section-row">
                        <Col className="title" xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Física:</Col>
                            <Col><b>Não solicitada</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
              }
            </div>
          )
        }

        {
          parameters.selectedType.id === 2
          && parameters.layer2040
          && (
            <div>
              <Row className="param-row">
                Amostragem da camada 20-40cm
              </Row>
              {
                parameters.layer2040
                  ? (
                    <div>
                      <Row className="section-row">
                        <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Rotina, Alumínio e Enxofre:</Col>
                            <Col><b>{`Proporção ${parameters.proportionRotina2040}`}</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
                  : (
                    <div>
                      <Row className="section-row">
                        <Col xs={{ offset: 0, span: 24 }} lg={{ offset: 1, span: 23 }}>
                          <Row justify="space-between">
                            <Col>Rotina, Alumínio e Enxofre:</Col>
                            <Col><b>Não solicitada</b></Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )
              }
            </div>
          )
        }
      </Col>
    </Row>
  );

  const handleSubmit = async (): Promise<void> => {
    setLoading(true);
    try {
      await formInstance.validateFields();
    } catch (error) {
      setLoading(false);
      return;
    }

    const obs = formInstance.getFieldValue('observacao');
    let telValue = formInstance.getFieldValue('TelInput');
    telValue = !telValue ? '' : telValue.replace(/\D/g, '');

    const data = {
      landFieldsIds: params.talhoesSelecionados.map((v) => v.id),
      landId: params.selectedProperty.id,
      landOwnerId: params.selectedOwner.id,
      serviceId: params.selectedService.id,
      serviceTypeDynamicFields: [],
      cooperativeNotes: obs,
      telephone: telValue,
      haveCtc: params.haveCtc,
      ctc: params.ctc,
      branchCoopercitrusId: params.branchCoopercitrusId,
    };

    let targetUrl = '';
    if (params.choiceServiceType === 1) {
      targetUrl = '/budget/requestBudgetService'; // solicitação de novo orçamento
    } else {
      targetUrl = '/service/requestService'; // solicitação de novo serviço
    }

    if (params?.selectedType?.id) {
      data.serviceTypeId = params.selectedType.id;

      if (params.serviceTypeDynamicFields.length > 0) {
        const dynamicFields = [];

        params.serviceTypeDynamicFields.forEach((v) => {
          if (params.dynamicFields[`dynamicField${v.id}`] !== undefined) {
            dynamicFields.push({
              id: v.id,
              value: params.dynamicFields[`dynamicField${v.id}`],
            });
          }
        });

        data.serviceTypeDynamicFields = dynamicFields;
      }
    }

    if (params.selectedSubType != null && params.selectedSubType.id) {
      const serviceSubtypeId = params.selectedSubType.id;
      data.serviceSubtypeId = serviceSubtypeId;
    }

    const subTypeDynamicFields = [];

    if (params.serviceSubtypeDynamicFields.length > 0) {
      params.serviceSubtypeDynamicFields.forEach((v) => {
        if (params.subTypeDynamicFields[`subTypeDynamicField${v.id}`] !== undefined) {
          subTypeDynamicFields.push({
            id: v.id,
            value: params.subTypeDynamicFields[`subTypeDynamicField${v.id}`],
          });
        }
      });

      data.serviceSubtypeDynamicFields = subTypeDynamicFields;
    }

    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    try {
      const requestRef: RequestWrapper = post({
        url: targetUrl,
        params: data,

        frontConfigs: {
          navigateFunction: navigate,
        },
      });

      response = await requestRef;
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    setLoading(false);

    switch (true) {
      case (response?.body?.code === 5002): {
        flushSync(() => {
          setRequestId(response?.body?.createServiceRequestOutput?.serviceRequestId);
        });

        const uploadError = !uploadFilesReference.current.validateFiles();

        if (!uploadError) {
          try {
            await uploadFilesReference.current.handleSubmitFiles();
          } catch (error) {
            setLoading(false);
            return;
          }

          nextPage({});
        }
      } break;

      case (response?.body?.code === 13001):
      case (response?.body?.code === 5013): {
        // "Budget requested successfully", 13001
        // "Service request edited successfully", 5013
        flushSync(() => {
          setRequestId(response?.body.createBudgetOutput.budgetId);
        });
        const uploadError = !uploadFilesReference?.current?.validateFiles();
        if (!uploadError) {
          try {
            await uploadFilesReference?.current?.handleSubmitFiles();
          } catch (error: unknown) {
            setLoading(false);
            return;
          }

          nextPage({});
        }
      } break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (responseError?.body?.code === -4003):
        // "You do not have permission to perform this operation", -4003
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .General.Forbidden
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6007):
        // "Land owner not found", -6007
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandOwnerNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6009):
        // "Land owner is not from an activated matriculation", -6009
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandOwnerIsNotFromAnActivatedMatriculation
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6002):
        // "Land not found", -6002
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6008):
        // "Land owner do not matches with land", -6008
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandOwnerDoNotMatchesWithLand
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5000):
        // "Service not found", -5000
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ServiceNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5017):
        // "Min quantity of unreached hectare", -5017
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.MinQuantityOfUnreachedHectare
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5001):
        // "Service type not found", -5001
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ServiceTypeNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5028):
        // "Cooperative notes too large", -5028
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.CooperativeNotesTooLarge
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5024):
        // "Coopercitrus notes too large", -5024
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.CooperCitrusNotesTooLarge
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5023):
        // "Telephone can not be null", -5023
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.TelephoneCanNotBeNull
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5021):
        // "Telephone size is too large", -5021
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.TelephoneSizeTooLarge
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5022):
        // "Telephone size is too small", -5022
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.TelephoneSizeTooSmall
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5030):
        // "mandatory fill ctc", -5030
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.mandatoryFillCtc
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5031):
        // "required branch", -5031
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.requiredBranch
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5003):
        // "Service subtype not found", -5003
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ServiceSubtypeNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6004):
        // "Land field is not from informed land", -6004
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandFieldIsNotFromInformedLand
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6017):
        // "Land with different cultures", -6017
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.LandsWithDifferentCultures
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5029):
        // "Problems with depths values", -5029
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ProblemsWithDepthsValues
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6005):
        // "Culture not found", -6005
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.CultureNotFound
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5027):
        // "Without weed map you cannot continue", -5027
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ServiceSubtypeNoWeedMap
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5002):
        // "Service type dont match with service", -5002
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.ServiceTypeDontMatchWithService
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -6006):
        // "This culture is not valid for this service", -6006
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Land.ThisCultureIsNotValidForThisService
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5006):
        // "Invalid service type dynamic fields", -5006
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.InvalidServiceTypeDynamicFields
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5005):
        // "Invalid service subtype dynamic fields", -5005
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.InvalidServiceSubtypeDynamicFields
            .description.pt_br,
        });
        break;

      case (responseError?.body?.code === -5032):
        // "Technician not found", -5032
        notification.error({
          message: 'Erro',
          description: backendResponseCodes.Error
            .Service.TechnicianNotFound
            .description.pt_br,
        });
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      case (responseError?.body?.code === -4000):
      default:
        // "Something unexpected happened", -4000
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao solicitar o serviço, por tente novamente',
        });
        break;
    }
  };

  const generateFieldName = (typeOrSubtype, field): string => {
    if (typeOrSubtype === 'subtype') {
      return `subTypeDynamicField${field.id}`;
    }

    return `dynamicField${field.id}`;
  };

  const renderDynamicFieldSummary = (field, arrayDynamicFields, typeOrSubType): JSX.Element | null => {
    const value = arrayDynamicFields[generateFieldName(typeOrSubType, field)];

    if (getUserType() === 'COOPERCITRUS') {
      if (value !== undefined) {
        if (field.typeValue === 'DOUBLE' && arrIdsCodeEstimateFloat.includes(field.idCode)) {
          if (field.name === 'Valor unitário') {
            titleOrcamento.current = true;
          }

          return (
            <Row className="param-row" key={field.id}>
              <Col span={24}>
                {
                  field.name === 'Valor unitário' && arrIdsCodeEstimateFloat.includes(field.idCode)
                  && (
                    <>
                      <hr />
                      <p className="Summary__SessionTitle">Orçamento</p>
                    </>
                  )
                }
                <Row justify="space-between">
                  <Col>{`${field.name}`}</Col>
                  <Col><b>{currencyFormatter.format(value)}</b></Col>
                </Row>
              </Col>
            </Row>
          );
        }

        if (titleOrcamento.current === false && field.typeValue === 'STRING' && arrIdsCodeEstimateString.includes(field.idCode)) {
          return (
            <Row className="param-row" key={field.id}>
              <Col span={24}>
                {
                  field.name === 'Observações do orçamento' && arrIdsCodeEstimateString.includes(field.idCode)
                  && (
                    <>
                      <hr />
                      <p className="Summary__SessionTitle">Orçamento</p>
                    </>
                  )
                }
                <Row justify="space-between">
                  <Col>{`${field.name}`}</Col>
                  <Col><b>{value}</b></Col>
                </Row>
              </Col>
            </Row>
          );
        }
      }
    }

    if (field.typeValue === 'BOOLEAN') {
      return (
        <Row className="param-row" key={field.id}>
          <Col span={24}>
            <Row justify="space-between">
              <Col>{`${field.name}`}</Col>
              <Col><b>{value ? 'Sim' : 'Não'}</b></Col>
            </Row>
          </Col>
        </Row>
      );
    }

    if (value == null || value == '' || value == undefined) {
      return null;
    }

    if (field.typeValue === 'DATE') {
      return (
        <Row className="param-row" key={field.id}>
          <Col span={24}>
            <Row justify="space-between">
              <Col>{`${field.name}`}</Col>
              <Col><b>{value instanceof moment ? value.format(dateFormat) : value}</b></Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return (
      <Row className="param-row" key={field.id}>
        <Col span={24}>
          <Row justify="space-between">
            <Col>{`${field.name}`}</Col>
            <Col><b>{value}</b></Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <div className="Summary">
      <Row gutter={24}>
        <Col xs={{ span: 24 }} lg={{ span: 12 }}>
          <div style={{ maxWidth: 470 }}>
            <Row className="param-row" style={{ alignItems: 'baseline' }}>
              <span className="service-title">
                {params.selectedService.name}
                {!!params.selectedType.id && ':'}
              </span>
              &nbsp;
              {
                !!params.selectedType.id
                && (
                  <span className="service-type">{params.selectedType.name}</span>
                )
              }
            </Row>

            {
              params.type !== undefined
              && (
                <Row className="param-row">
                  <Col>
                    <b>Tipo:</b>
                    {` ${params.type}`}
                  </Col>
                </Row>
              )
            }

            <Row className="param-row">
              <Col>
                {`Matrícula: ${params.selectedProperty.matriculation}`}
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                {`Cooperado: ${params.selectedOwner.name}`}
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                {`Propriedade: ${params.selectedProperty.name}`}
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                {
                  userMailCooperative()
                }
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                <span>{`Possui CTC: ${params.haveCtc ? 'Sim' : 'Não'}`}</span>
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                <span>{`CTC: ${params.ctc ? params.ctc : '-'}`}</span>
              </Col>
            </Row>

            <Row className="param-row">
              <Col>
                <span>{`Filial: ${params.branchName ? params.branchName : '-'}`}</span>
              </Col>
            </Row>

            {getGeofertGridSummary(params)}

            {
              params.dynamicFields
              && params.serviceTypeDynamicFields
              && params.serviceTypeDynamicFields.map(
                (v) => renderDynamicFieldSummary(v, params.dynamicFields, 'type'),
              )
            }
            {
              params.subTypeDynamicFields
              && params.serviceSubtypeDynamicFields
              && params.serviceSubtypeDynamicFields.map(
                (v) => renderDynamicFieldSummary(v, params.subTypeDynamicFields, 'subtype'),
              )
            }

            <Row className="param-row" key="tel">
              <Col span={24}>
                <Row justify="space-between">
                  <Row className="param-row" style={{ alignItems: 'baseline' }}>
                    <span className="input-required service-type" style={{ alignItems: 'center', display: 'flex' }}>
                      Telefone para contato
                    </span>
                  </Row>
                </Row>
              </Col>
            </Row>

            <Row>
              <Form
                scrollToFirstError
                form={formInstance}
              >
                <Col span={24}>
                  <Form.Item
                    name="TelInput"
                    validateTrigger={['onBlur']}
                    rules={[
                      {
                        required: true,
                        message: 'Por favor, insira um telefone.',
                      },
                      {
                        min: 14,
                        message: 'Telefone inválido',
                      },
                    ]}
                  >
                    <MaskedInput
                      guide={false}
                      mask={mask}
                      placeholder="Telefone"
                      className="ant-input"
                      maxLength={15}
                    />
                  </Form.Item>
                </Col>
              </Form>
            </Row>

            <Row className="param-row">
              <Col span={24}>
                <Row justify="space-between">
                  <Col>
                    <span className="service-type"> Observação </span>
                  </Col>
                </Row>
                <Row>
                  <Form
                    scrollToFirstError
                    form={formInstance}
                  >
                    <Form.Item
                      name="observacao"
                      rules={[
                        { max: 1000, message: 'A observação deve ter no máximo 1000 caractéres' },
                      ]}
                    >
                      <TextArea className="obsArea" xs={{ span: 24 }} lg={{ span: 10 }} rows={4} />
                    </Form.Item>
                  </Form>
                </Row>
              </Col>
            </Row>

            <Row className="param-row">
              <Col span={24}>
                <Row justify="space-between">
                  <Col>
                    <span className="service-type"> Anexos do Cooperado </span>
                  </Col>
                </Row>
                <Row>
                  <Form
                    scrollToFirstError
                    form={formInstance}
                  >
                    <Form.Item
                      name="anexo"
                    >
                      <div className="attachments-items-container">
                        <UploadFiles
                          ref={uploadFilesReference}
                          origin="summary"
                          requestType={
                            isItEstimateOrService(
                              params.choiceServiceType === 1 ? 'ORCAMENTO' : 'SERVICO',
                              getUserType(),
                            )
                          }
                          typeUser="SERVICE_REQUEST_CUSTOMER_FILE"
                          action="edit"
                          id={requestId}
                          fileSize={maxSizeCooperated}
                          initialFiles={
                            [].map((item) => ({ ...item, uid: item.id, status: 'done' }))
                          }
                        />
                      </div>
                    </Form.Item>
                  </Form>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>

        <Col xs={{ span: 24 }} lg={{ span: 12 }} style={{ paddingTop: 15 }}>
          <SelectedLands
            talhoesSelecionados={params.talhoesSelecionados}
            removeSelectedField={removeSelectedField}
          />
          <AreaTalhao talhoesSelecionados={params.talhoesSelecionados} />
          {
            isCurrentPage
            && (<GeoMapSummary params={params} />)
          }
        </Col>
      </Row>

      <div className="controls-container">
        <Button
          className="btn-previus-step"
          onClick={
            (): void => {
              previousPage();
            }
          }
          loading={loading}
        >
          <ArrowLeftIcon />
          voltar
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={loading}
        >
          Confirmar solicitação
        </Button>
      </div>
    </div>
  );
};

Summary.propTypes = {
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  removeSelectedField: PropTypes.func.isRequired,
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  isCurrentPage: PropTypes.bool.isRequired,
  // params: PropTypes.shape({
  //   service: PropTypes.string,
  //   dynamicFields: PropTypes.objectOf(PropTypes.any),
  //   serviceTypeDynamicFields: PropTypes.objectOf(PropTypes.any).isRequired,
  //   talhoesSelecionados: PropTypes.objectOf(PropTypes.any).isRequired,
  //   serviceSubtypeDynamicFields: PropTypes.objectOf(PropTypes.any).isRequired,
  //   subTypeDynamicFields: PropTypes.objectOf(PropTypes.any).isRequired,
  //
  //   layer020Rotina: PropTypes.objectOf(PropTypes.any).isRequired,
  //   proportionRotina020: PropTypes.objectOf(PropTypes.any).isRequired,
  //   layer020Micro: PropTypes.objectOf(PropTypes.any).isRequired,
  //   proportionMicro020: PropTypes.objectOf(PropTypes.any).isRequired,
  //   layer020Fisica: PropTypes.objectOf(PropTypes.any).isRequired,
  //   proportionFisica020: PropTypes.objectOf(PropTypes.any).isRequired,
  //   layer2040: PropTypes.objectOf(PropTypes.any).isRequired,
  //   proportionRotina2040: PropTypes.objectOf(PropTypes.any).isRequired,
  //   gridSize: PropTypes.objectOf(PropTypes.any).isRequired,
  //   type: PropTypes.objectOf(PropTypes.any).isRequired,
  //   selectedService: PropTypes.shape({
  //     id: PropTypes.number,
  //     name: PropTypes.string,
  //   }),
  //   selectedType: PropTypes.shape({
  //     id: PropTypes.number,
  //     name: PropTypes.string,
  //   }),
  //   selectedOwner: PropTypes.shape({
  //     id: PropTypes.number,
  //     name: PropTypes.string,
  //   }),
  //   selectedProperty: PropTypes.shape({
  //     id: PropTypes.number,
  //     name: PropTypes.string,
  //     matriculation: PropTypes.string,
  //   }),
  //   gridType: PropTypes.shape({
  //     val: PropTypes.number,
  //   }),
  // }).isRequired,
};

Summary.defaultProps = {};

export default Summary;
